// AddStudent.js
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Table, Form, Card, Alert } from 'react-bootstrap';
import axios from 'axios';
import * as XLSX from 'xlsx';
import 'bootstrap/dist/css/bootstrap.min.css';

const AddStudent = () => {
  const [students, setStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [studentsPerPage] = useState(5);
  const [formData, setFormData] = useState({
    id: '',
    fullName: '',
    Father: '',
    dateOfBirth: '',
    M_F: '',
    scholerNo: '',
    tcPdf: null,
  });
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    try {
      const response = await axios.get('http://localhost:5000/students');
      setStudents(response.data);
    } catch (error) {
      console.error('Error fetching students:', error);
    }
  };

  const addOrUpdateStudent = async () => {
    if (!formData.fullName || !formData.Father || !formData.dateOfBirth || !formData.scholerNo) {
      alert('Please fill in all required fields.');
      return;
    }

    const studentFormData = new FormData();
    Object.keys(formData).forEach((key) => {
      studentFormData.append(key, formData[key]);
    });

    try {
      if (formData.id) {
        await axios.put(`http://localhost:5000/students/${formData.id}`, studentFormData);
      } else {
        await axios.post('http://localhost:5000/students', studentFormData);
      }
      fetchStudents();  // Fetch the updated list of students
      setShowSuccess(true);
      resetFormData();
    } catch (error) {
      console.error('There was an error saving the student data!', error);
    }
  };

  const deleteStudent = async (id) => {
    try {
      await axios.delete(`http://localhost:5000/students/${id}`);
      fetchStudents();
    } catch (error) {
      console.error('There was an error deleting the student data!', error);
    }
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1); // Reset current page to 1 when searching
  };

  const resetFormData = () => {
    setFormData({
      id: '',
      fullName: '',
      Father: '',
      dateOfBirth: '',
      M_F: '',
      scholerNo: '',
      tcPdf: null,
    });
  };

  const handleFileUpload = (event) => {
    setFormData({ ...formData, tcPdf: event.target.files[0] });
  };

  const saveToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(students);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Students');
    XLSX.writeFile(workbook, 'students.xlsx');
  };

  const indexOfLastStudent = currentPage * studentsPerPage;
  const indexOfFirstStudent = indexOfLastStudent - studentsPerPage;
  const currentStudents = students
    .filter((student) =>
      student.fullName && student.fullName.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .slice(indexOfFirstStudent, indexOfLastStudent);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="login-bg">
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12} sm={8} md={10}>
            <Card className="mb-4">
              <Card.Header>
                <Form.Group controlId="search">
                  <Form.Control
                    type="text"
                    placeholder="Search by name"
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </Form.Group>
              </Card.Header>
              <Card.Body>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Father</th>
                      <th>Date of Birth</th>
                      <th>M/F</th>
                      <th>Scholer No.</th>
                      <th>TC PDF</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentStudents.map((student) => (
                      <tr key={student.id}>
                        <td>{student.id}</td>
                        <td>{student.fullName}</td>
                        <td>{student.Father}</td>
                        <td>{student.dateOfBirth}</td>
                        <td>{student.M_F}</td>
                        <td>{student.scholerNo}</td>
                        <td>
                          {student.tcPdf ? (
                            <a href={student.tcPdf} target="_blank" rel="noopener noreferrer">
                              View PDF
                            </a>
                          ) : (
                            'No PDF'
                          )}
                        </td>
                        <td>
                          <Button variant="danger" onClick={() => deleteStudent(student.id)}>
                            Delete
                          </Button>
                          <Button variant="primary" onClick={() => setFormData({ ...student })}>
                            Edit
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <Pagination
                  studentsPerPage={studentsPerPage}
                  totalStudents={students.length}
                  paginate={paginate}
                />
              </Card.Body>
            </Card>
            <Card>
              <Card.Header>Add / Update Student</Card.Header>
              <Card.Body>
                {showSuccess && <Alert variant="success">Student submitted successfully!</Alert>}
                <Form>
                  <Form.Group controlId="fullName">
                    <Form.Label>Full Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter full name"
                      value={formData.fullName}
                      onChange={(e) => setFormData({ ...formData, fullName: e.target.value })}
                    />
                  </Form.Group>
                  <Form.Group controlId="Father">
                    <Form.Label>Father's Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter father's name"
                      value={formData.Father}
                      onChange={(e) => setFormData({ ...formData, Father: e.target.value })}
                    />
                  </Form.Group>
                  <Form.Group controlId="dateOfBirth">
                    <Form.Label>Date of Birth</Form.Label>
                    <Form.Control
                      type="date"
                      value={formData.dateOfBirth}
                      onChange={(e) => setFormData({ ...formData, dateOfBirth: e.target.value })}
                    />
                  </Form.Group>
                  <Form.Group controlId="M_F">
                    <Form.Label>Gender</Form.Label>
                    <div>
                      <Form.Check
                        inline
                        label="Male"
                        name="gender"
                        type="radio"
                        id="male"
                        checked={formData.M_F === 'M'}
                        onChange={() => setFormData({ ...formData, M_F: 'M' })}
                      />
                      <Form.Check
                        inline
                        label="Female"
                        name="gender"
                        type="radio"
                        id="female"
                        checked={formData.M_F === 'F'}
                        onChange={() => setFormData({ ...formData, M_F: 'F' })}
                      />
                    </div>
                  </Form.Group>
                  <Form.Group controlId="scholerNo">
                    <Form.Label>Scholer Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter scholer number"
                      value={formData.scholerNo}
                      onChange={(e) => setFormData({ ...formData, scholerNo: e.target.value })}
                    />
                  </Form.Group>
                  <Form.Group controlId="tcPdf">
                    <Form.Label>TC PDF</Form.Label>
                    <Form.Control type="file" onChange={handleFileUpload} />
                  </Form.Group>
                  <Button variant="success" onClick={addOrUpdateStudent}>
                    {formData.id ? 'Update Student' : 'Add Student'}
                  </Button>
                </Form>
                <Button variant="secondary" onClick={saveToExcel} className="mt-3">
                  Save to Excel
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const Pagination = ({ studentsPerPage, totalStudents, paginate }) => {
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalStudents / studentsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav>
      <ul className="pagination">
        {pageNumbers.map((number) => (
          <li key={number} className="page-item">
            <button onClick={() => paginate(number)} className="page-link">
              {number}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default AddStudent;

